var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.28574",
      "conversations-internal-schema": "static-1.13557",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8460",
      "hubspot-url-utils": "static-1.4421",
      "HubStyleTokens": "static-2.11914",
      "I18n": "static-7.1695",
      "jasmine-runner": "static-1.6872",
      "quartz": "static-1.7596",
      "react": "static-7.202",
      "reselect": "static-3.15",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.514",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6579",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "moment": "static-3.75",
      "customer-data-email": "static-1.18589",
      "cv-backend-services": "static-1.1607",
      "hub-http": "static-1.6631",
      "immutable": "static-2.90",
      "immutable-less": "static-1.5072",
      "quartz-config": "static-1.1374",
      "quartz-core": "static-1.6815",
      "transmute": "static-2.97",
      "HeadJS": "static-2.814",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8668",
      "framer-motion": "static-1.83",
      "hs-test-utils-bend-plugin": "static-1.3571",
      "msw": "static-1.102",
      "msw-config": "static-1.22",
      "react-redux": "static-7.83",
      "redux": "static-4.83",
      "testing-library": "static-1.163",
      "foundations-theming": "static-1.4904",
      "i18n-data": "static-1.233",
      "metrics-js": "static-1.10059",
      "moment-timezone": "static-5.94",
      "react-utils": "static-2.5629",
      "jasmine": "static-4.4730",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3308",
      "react-aria": "static-1.76",
      "styled-components": "static-2.103",
      "UIComponents": "static-3.8860",
      "visitor-ui-component-library-icons": "static-1.6390",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5022",
      "apollo-stack-hubspot": "static-3.98",
      "classnames": "static-2.10",
      "cssUtils": "static-1.1044",
      "customer-data-objects": "static-1.8115",
      "customer-data-ui-utilities": "static-1.10255",
      "data-fetching-client": "static-1.10069",
      "FileManagerCore": "static-1.40253",
      "FileManagerLib": "static-1.40394",
      "foundations-assets": "static-1.5307",
      "graphql": "static-1.92",
      "hs-promise-utils": "static-1.6011",
      "hubspot-apollo-client": "static-1.5299",
      "icons": "static-2.699",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.117",
      "react-virtualized": "static-2.111",
      "rpc-client-utils": "static-1.5091",
      "salesImages": "static-1.679",
      "timezone-utils": "static-2.5653",
      "ui-gdpr-components": "static-1.10651",
      "ts-schema": "static-1.4367",
      "hs-locale-management": "static-1.367",
      "hs-lodash": "static-4.45",
      "immer": "static-1.104",
      "opentelemetry-fe-types": "static-1.209",
      "dispatcher": "static-1.146",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.899",
      "hubspotter-http": "static-1.4934",
      "mobile-manifest-mixins": "static-1.597",
      "module-federation": "static-1.37",
      "opentelemetry-fe": "static-1.584",
      "quartz-auth": "static-1.1271",
      "quartz-head": "static-1.1261",
      "quartz-i18n": "static-1.1271",
      "quartz-routing": "static-1.1026",
      "quartz-test": "static-1.1271",
      "quartz-tracking": "static-1.975",
      "quick-fetch": "static-1.4197",
      "react-rhumb": "static-1.17155",
      "trellis-components": "static-1.2984",
      "ui-fonts": "static-1.1176",
      "usage-tracker-container": "static-1.7726",
      "usage-tracker-core": "static-1.7586",
      "bend-plugin-foundations-components": "static-1.4937",
      "floating-ui": "static-1.67",
      "foundations-theming-specialty": "static-1.2620",
      "hs-story-utils": "static-1.9847",
      "react-create-root-preference": "static-1.93",
      "tanstack-table": "static-1.65",
      "trellis-assets": "static-1.2965",
      "ui-images": "static-2.1269",
      "bender-build-tools": "static-1.3518",
      "bend-plugin-foundations-theming": "static-1.3387",
      "foundations-theming-base": "static-1.3889",
      "stylex": "static-1.45",
      "beacon-keepalive-queue": "static-1.122",
      "bend-plugin-metrics-js": "static-1.36",
      "HubStyle": "static-2.12221",
      "sassPrefix": "static-1.310",
      "inbound-db-properties-service-client": "static-1.4114",
      "property-translator": "static-1.5801",
      "react-dnd-compat": "static-1.5032",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9935",
      "breeze-artifacts-sdk": "static-1.706",
      "copilot-toolkit": "static-1.12057",
      "audio-components": "static-1.6498",
      "ContentUtils": "static-1.69354",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29985",
      "file-manager-components": "static-1.24754",
      "FileManagerImages": "static-1.37905",
      "foundations-components-legacy": "static-1.1693",
      "html-to-image": "static-1.64",
      "immerable": "static-1.4563",
      "react-colorpicker": "static-2.10635",
      "redux-toolkit": "static-1.81",
      "ui-universal-auth": "static-1.9633",
      "urlinator": "static-1.4938",
      "usage-tracker": "static-1.7736",
      "video-components": "static-1.14344",
      "video-data-lib": "static-1.36000",
      "video-embed": "static-1.36834",
      "redux-thunk": "static-2.83",
      "hubspot-apollo-cache": "static-1.758",
      "bend-plugin-chirp-manifest": "static-1.501",
      "chirp-fetch": "static-1.2323",
      "opentelemetry-web": "static-1.20",
      "hub-http-shared-msw-handlers": "static-1.10818",
      "hubspotter-http-shared-msw-handlers": "static-1.10816",
      "usage-tracker-session-replay": "static-1.5422",
      "web-vitals": "static-1.18",
      "base-ui": "static-1.26",
      "react-day-picker": "static-1.14",
      "trellis-theming": "static-1.1407",
      "tanstack-virtual": "static-1.42",
      "stylex-utils": "static-1.163",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.23548",
      "customer-data-objects-ui-components": "static-1.13452",
      "sanitize": "static-1.4895",
      "sanitize-text": "static-1.8578",
      "breeze-engine-lib": "static-1.2020",
      "magpie-lib": "static-1.5858",
      "magpie-types": "static-1.5318",
      "simple-logging-lib": "static-1.3473",
      "superstore": "static-1.5180",
      "content-assistance-lib": "static-1.8350",
      "cms-field-types": "static-1.5234",
      "content-icons-ui": "static-1.2418",
      "integrations-lib": "static-1.17314",
      "underscore": "static-1.8",
      "nudge-client-utils": "static-1.3331",
      "poll-commands": "static-1.3896",
      "ui-addon-iframeable": "static-1.9499",
      "video-components-external": "static-1.12342",
      "unified-auth-core-lib": "static-1.1429",
      "social-insights-client-types": "static-1.22849",
      "SharedI18nStrings": "static-1.186",
      "outpost": "static-1.4555",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "atom": "static-1.5499",
      "avatar-components": "static-1.2906",
      "reference-resolvers": "static-1.8599",
      "breeze-engine-chat-components": "static-1.998",
      "breeze-engine-core": "static-1.1298",
      "ably": "static-2.2",
      "highlight.js": "static-1.89",
      "batch-promise": "static-1.1968",
      "pulse": "static-1.1063",
      "idb-keyval": "static-1.54",
      "reactive-lib": "static-1.1145",
      "ui-addon-video-player": "static-1.9057",
      "ui-coaching-tips": "static-1.29517",
      "flux-actions": "static-1.380",
      "frontend-preferences-client": "static-1.8340",
      "integrations-error-boundary-lib": "static-1.14729",
      "integrations-tracking-lib": "static-1.6033",
      "laboratory-lib": "static-3.7572",
      "native-integrations-shared-strings": "static-1.8184",
      "redux-observable": "static-1.78",
      "ReduxMessenger": "static-2.10793",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11568",
      "ui-shepherd-react": "static-3.10696",
      "unified-auth": "static-1.1147",
      "nudge-custom-function-registry": "static-1.3088",
      "nudge-renderer-utils": "static-1.3407",
      "onboarding-tours": "static-1.17313",
      "whisper-core-api": "static-1.7549",
      "navigation-messaging": "static-1.8399",
      "content-media-composition-data-lib": "static-1.13494",
      "content-media-compositions": "static-2.17501",
      "media-bridge-lib": "static-1.19566",
      "fsm": "static-1.4176",
      "bend-plugin-pulse": "static-1.566",
      "event-emitter": "static-1.1381",
      "fast-json-patch": "static-1.73",
      "react-dlb": "static-1.92",
      "growth-onboarding-feedback-components": "static-1.7004",
      "universal-page-editor-lib": "static-1.3431",
      "foundations-components-test-utils": "static-1.6151",
      "adobe-sign-auth-lib": "static-1.676",
      "ads-unified-auth-lib": "static-1.1778",
      "custom-vendor-connection-lib": "static-1.197",
      "google-sheets-integration-lib": "static-1.1243",
      "microsoft-drive-auth-lib": "static-1.403",
      "surveymonkey-integration-lib": "static-1.771",
      "slack-ui-library": "static-1.10819",
      "getting-started-shared-tasks": "static-1.19475",
      "growth-data-modal": "static-1.6059",
      "growth-onboarding-confetti": "static-1.3485",
      "growth-onboarding-next-action-utils": "static-1.2899",
      "navigation-components": "static-1.19072",
      "onboarding-tours-client": "static-1.5528",
      "onboarding-tours-utils": "static-1.1380",
      "ui-shepherd-tracker": "static-1.8077",
      "user-context": "static-1.5480",
      "js-cookie": "static-1.18",
      "crm-record-cards-service-types": "static-1.3836",
      "framework-data-schema-resolvers": "static-1.7314",
      "location-customization-utils-lib": "static-1.10330",
      "onboarding-data-sync-lib": "static-1.2762",
      "growth-onboarding-next-action-components": "static-1.2927",
      "user-context-client": "static-1.4931",
      "nest": "static-1.657",
      "getting-started-shared-tasks-store": "static-1.18593",
      "conditional-properties-service-client": "static-1.4087",
      "crm-pipelines-api-client-types": "static-1.4418",
      "fdsr-migration-layer": "static-1.433",
      "framework-builder-read-service-client": "static-1.4294",
      "framework-data-schema-quick-fetch": "static-1.7219",
      "inbound-db-meta-service-client": "static-1.3745",
      "multi-currency-client-types": "static-1.3983",
      "persist-promise": "static-1.4125",
      "InboxConnectUtils": "static-4.15758",
      "meetings-connect-utils-lib": "static-1.8038",
      "onboarding-scopes": "static-1.6874",
      "hub-http-contrib": "static-1.3450",
      "ui-addon-sales-email": "static-1.5624"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.28574",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13557",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8460",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4421",
      "HubStyleTokens": "/HubStyleTokens/static-2.11914",
      "I18n": "/I18n/static-7.1695",
      "jasmine-runner": "/jasmine-runner/static-1.6872",
      "quartz": "/quartz/static-1.7596",
      "react": "/react/static-7.202",
      "reselect": "/reselect/static-3.15",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.514",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6579",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "moment": "/moment/static-3.75",
      "customer-data-email": "/customer-data-email/static-1.18589",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "hub-http": "/hub-http/static-1.6631",
      "immutable": "/immutable/static-2.90",
      "immutable-less": "/immutable-less/static-1.5072",
      "quartz-config": "/quartz-config/static-1.1374",
      "quartz-core": "/quartz-core/static-1.6815",
      "transmute": "/transmute/static-2.97",
      "HeadJS": "/HeadJS/static-2.814",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8668",
      "framer-motion": "/framer-motion/static-1.83",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3571",
      "msw": "/msw/static-1.102",
      "msw-config": "/msw-config/static-1.22",
      "react-redux": "/react-redux/static-7.83",
      "redux": "/redux/static-4.83",
      "testing-library": "/testing-library/static-1.163",
      "foundations-theming": "/foundations-theming/static-1.4904",
      "i18n-data": "/i18n-data/static-1.233",
      "metrics-js": "/metrics-js/static-1.10059",
      "moment-timezone": "/moment-timezone/static-5.94",
      "react-utils": "/react-utils/static-2.5629",
      "jasmine": "/jasmine/static-4.4730",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3308",
      "react-aria": "/react-aria/static-1.76",
      "styled-components": "/styled-components/static-2.103",
      "UIComponents": "/UIComponents/static-3.8860",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6390",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.1044",
      "customer-data-objects": "/customer-data-objects/static-1.8115",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10255",
      "data-fetching-client": "/data-fetching-client/static-1.10069",
      "FileManagerCore": "/FileManagerCore/static-1.40253",
      "FileManagerLib": "/FileManagerLib/static-1.40394",
      "foundations-assets": "/foundations-assets/static-1.5307",
      "graphql": "/graphql/static-1.92",
      "hs-promise-utils": "/hs-promise-utils/static-1.6011",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5299",
      "icons": "/icons/static-2.699",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.117",
      "react-virtualized": "/react-virtualized/static-2.111",
      "rpc-client-utils": "/rpc-client-utils/static-1.5091",
      "salesImages": "/salesImages/static-1.679",
      "timezone-utils": "/timezone-utils/static-2.5653",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
      "ts-schema": "/ts-schema/static-1.4367",
      "hs-locale-management": "/hs-locale-management/static-1.367",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.104",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.209",
      "dispatcher": "/dispatcher/static-1.146",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.899",
      "hubspotter-http": "/hubspotter-http/static-1.4934",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.597",
      "module-federation": "/module-federation/static-1.37",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.584",
      "quartz-auth": "/quartz-auth/static-1.1271",
      "quartz-head": "/quartz-head/static-1.1261",
      "quartz-i18n": "/quartz-i18n/static-1.1271",
      "quartz-routing": "/quartz-routing/static-1.1026",
      "quartz-test": "/quartz-test/static-1.1271",
      "quartz-tracking": "/quartz-tracking/static-1.975",
      "quick-fetch": "/quick-fetch/static-1.4197",
      "react-rhumb": "/react-rhumb/static-1.17155",
      "trellis-components": "/trellis-components/static-1.2984",
      "ui-fonts": "/ui-fonts/static-1.1176",
      "usage-tracker-container": "/usage-tracker-container/static-1.7726",
      "usage-tracker-core": "/usage-tracker-core/static-1.7586",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4937",
      "floating-ui": "/floating-ui/static-1.67",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2620",
      "hs-story-utils": "/hs-story-utils/static-1.9847",
      "react-create-root-preference": "/react-create-root-preference/static-1.93",
      "tanstack-table": "/tanstack-table/static-1.65",
      "trellis-assets": "/trellis-assets/static-1.2965",
      "ui-images": "/ui-images/static-2.1269",
      "bender-build-tools": "/bender-build-tools/static-1.3518",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3387",
      "foundations-theming-base": "/foundations-theming-base/static-1.3889",
      "stylex": "/stylex/static-1.45",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.122",
      "bend-plugin-metrics-js": "/bend-plugin-metrics-js/static-1.36",
      "HubStyle": "/HubStyle/static-2.12221",
      "sassPrefix": "/sassPrefix/static-1.310",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4114",
      "property-translator": "/property-translator/static-1.5801",
      "react-dnd-compat": "/react-dnd-compat/static-1.5032",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9935",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.706",
      "copilot-toolkit": "/copilot-toolkit/static-1.12057",
      "audio-components": "/audio-components/static-1.6498",
      "ContentUtils": "/ContentUtils/static-1.69354",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29985",
      "file-manager-components": "/file-manager-components/static-1.24754",
      "FileManagerImages": "/FileManagerImages/static-1.37905",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1693",
      "html-to-image": "/html-to-image/static-1.64",
      "immerable": "/immerable/static-1.4563",
      "react-colorpicker": "/react-colorpicker/static-2.10635",
      "redux-toolkit": "/redux-toolkit/static-1.81",
      "ui-universal-auth": "/ui-universal-auth/static-1.9633",
      "urlinator": "/urlinator/static-1.4938",
      "usage-tracker": "/usage-tracker/static-1.7736",
      "video-components": "/video-components/static-1.14344",
      "video-data-lib": "/video-data-lib/static-1.36000",
      "video-embed": "/video-embed/static-1.36834",
      "redux-thunk": "/redux-thunk/static-2.83",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.758",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.501",
      "chirp-fetch": "/chirp-fetch/static-1.2323",
      "opentelemetry-web": "/opentelemetry-web/static-1.20",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10818",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10816",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5422",
      "web-vitals": "/web-vitals/static-1.18",
      "base-ui": "/base-ui/static-1.26",
      "react-day-picker": "/react-day-picker/static-1.14",
      "trellis-theming": "/trellis-theming/static-1.1407",
      "tanstack-virtual": "/tanstack-virtual/static-1.42",
      "stylex-utils": "/stylex-utils/static-1.163",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.23548",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13452",
      "sanitize": "/sanitize/static-1.4895",
      "sanitize-text": "/sanitize-text/static-1.8578",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2020",
      "magpie-lib": "/magpie-lib/static-1.5858",
      "magpie-types": "/magpie-types/static-1.5318",
      "simple-logging-lib": "/simple-logging-lib/static-1.3473",
      "superstore": "/superstore/static-1.5180",
      "content-assistance-lib": "/content-assistance-lib/static-1.8350",
      "cms-field-types": "/cms-field-types/static-1.5234",
      "content-icons-ui": "/content-icons-ui/static-1.2418",
      "integrations-lib": "/integrations-lib/static-1.17314",
      "underscore": "/underscore/static-1.8",
      "nudge-client-utils": "/nudge-client-utils/static-1.3331",
      "poll-commands": "/poll-commands/static-1.3896",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9499",
      "video-components-external": "/video-components-external/static-1.12342",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1429",
      "social-insights-client-types": "/social-insights-client-types/static-1.22849",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
      "outpost": "/outpost/static-1.4555",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "atom": "/atom/static-1.5499",
      "avatar-components": "/avatar-components/static-1.2906",
      "reference-resolvers": "/reference-resolvers/static-1.8599",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.998",
      "breeze-engine-core": "/breeze-engine-core/static-1.1298",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.89",
      "batch-promise": "/batch-promise/static-1.1968",
      "pulse": "/pulse/static-1.1063",
      "idb-keyval": "/idb-keyval/static-1.54",
      "reactive-lib": "/reactive-lib/static-1.1145",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29517",
      "flux-actions": "/flux-actions/static-1.380",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8340",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14729",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6033",
      "laboratory-lib": "/laboratory-lib/static-3.7572",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8184",
      "redux-observable": "/redux-observable/static-1.78",
      "ReduxMessenger": "/ReduxMessenger/static-2.10793",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11568",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10696",
      "unified-auth": "/unified-auth/static-1.1147",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3088",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3407",
      "onboarding-tours": "/onboarding-tours/static-1.17313",
      "whisper-core-api": "/whisper-core-api/static-1.7549",
      "navigation-messaging": "/navigation-messaging/static-1.8399",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13494",
      "content-media-compositions": "/content-media-compositions/static-2.17501",
      "media-bridge-lib": "/media-bridge-lib/static-1.19566",
      "fsm": "/fsm/static-1.4176",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.566",
      "event-emitter": "/event-emitter/static-1.1381",
      "fast-json-patch": "/fast-json-patch/static-1.73",
      "react-dlb": "/react-dlb/static-1.92",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7004",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3431",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6151",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.676",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1778",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.197",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1243",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.403",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.771",
      "slack-ui-library": "/slack-ui-library/static-1.10819",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19475",
      "growth-data-modal": "/growth-data-modal/static-1.6059",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3485",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2899",
      "navigation-components": "/navigation-components/static-1.19072",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5528",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1380",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8077",
      "user-context": "/user-context/static-1.5480",
      "js-cookie": "/js-cookie/static-1.18",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3836",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7314",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10330",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2762",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2927",
      "user-context-client": "/user-context-client/static-1.4931",
      "nest": "/nest/static-1.657",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18593",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4087",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4418",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.433",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4294",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7219",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3745",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3983",
      "persist-promise": "/persist-promise/static-1.4125",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15758",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8038",
      "onboarding-scopes": "/onboarding-scopes/static-1.6874",
      "hub-http-contrib": "/hub-http-contrib/static-1.3450",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5624"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.28574",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};